import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 整箱、拼箱、空运 询价 查询
export function queryInquiryPrice(data) {
  return request({
    url: URL.price.queryInquiryPrice,
    method: 'post',
    data
  })
}

// 匹配 港前、尾程运价
export function matchPrice(data) {
  return request({
    url: URL.price.matchPrice,
    method: 'post',
    data
  })
}

// 详情 港前、尾程运价
export function inquiryDetail(data) {
  return request({
    url: URL.price.inquiryDetail,
    method: 'post',
    data
  })
}

// 整箱、拼箱、空运 询价保存
export function saveInquiryPrice(data) {
  return request({
    url: URL.price.saveInquiryPrice,
    method: 'post',
    data
  })
}

//  整箱、拼箱、空运 询价编辑状态
export function editInquiryPriceStatus(data) {
  return request({
    url: URL.price.editInquiryPriceStatus,
    method: 'post',
    data
  })
}

//  整箱、拼箱、空运 询价 复制
export function copyInquiryPrice(data) {
  return request({
    url: URL.price.copyInquiryPrice,
    method: 'post',
    data
  })
}

//  匹配航线负责人
export function matchResponsiblePerson(data) {
  return request({
    url: URL.price.matchResponsiblePerson,
    method: 'post',
    data
  })
}

//  整箱、拼箱、空运 询价提交
export function submitInquiryPrice(data) {
  return request({
    url: URL.price.submitInquiryPrice,
    method: 'post',
    data
  })
}

//  整箱、拼箱、空运 询价 保存并提交
export function saveAndSubmitInquiryPrice(data) {
  return request({
    url: URL.price.saveAndSubmitInquiryPrice,
    method: 'post',
    data
  })
}
